export const EXPIRY_ALERT_MIN_MONTHS     = 1;
export const EXPIRY_ALERT_MAX_MONTHS     = 6;
export const DEFAULT_EXPIRY_ALERT_MONTHS = 3;

// keeps the lead time inside the allowed 1..6 range (same rule as the API)
export function normalizeAlertMonths(months) {
   const value = parseInt(months);

   if (isNaN(value) || value < EXPIRY_ALERT_MIN_MONTHS || value > EXPIRY_ALERT_MAX_MONTHS) return DEFAULT_EXPIRY_ALERT_MONTHS;
   return value;
}

// 'YYYY-MM-DD' => local Date (no timezone shifting). Returns null for empty / invalid values
export function parseDate(dateString) {
   if (typeof dateString !== 'string') return null;

   const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateString.trim());
   if (!match) return null;

   const [year, month, day] = [Number(match[1]), Number(match[2]), Number(match[3])];
   const date = new Date(year, month - 1, day);

   if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
   return date;
}

// today + N months, the day is clamped (Aug 31 + 1 month = Sep 30)
export function addMonths(date, months) {
   const day    = date.getDate();
   const result = new Date(date.getFullYear(), date.getMonth() + months, 1);
   const last   = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate();

   result.setDate(Math.min(day, last));
   return result;
}

function startOfDay(date) {
   return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/**
 * status: 'none' (no date) | 'expired' | 'soon' (inside the alert lead time) | 'ok'
 * days: days until expiry (negative when expired), null when there is no date
 */
export function getExpiryStatus(dateString, months = DEFAULT_EXPIRY_ALERT_MONTHS, today = new Date()) {
   const expiry = parseDate(dateString);
   if (!expiry) return {status: 'none', days: null};

   const now  = startOfDay(today);
   const days = Math.round((expiry - now) / 86400000);

   if (expiry < now) return {status: 'expired', days};
   if (expiry <= addMonths(now, normalizeAlertMonths(months))) return {status: 'soon', days};

   return {status: 'ok', days};
}
